@let darkModeEnabled = darkModeService.darkModeEnabled;
@if (provider) {
  <div
    class="provider-tile"
    [class.card-disabled]="disabled"
    [class.card-interactive]="!disabled"
    [class.is-active]="active">
    <div class="provider-tile-container">
      <div class="provider-tile-top">
        <div
          class="provider-tile-image-container"
          [class.provider-tile-image-container-with-text]="!provider.isLogoDescriptive()">
          <a href="javascript:" [tabIndex]="-1">
            <img [src]="provider.getLogo(darkModeEnabled)" class="provider-tile-image" [alt]="provider.getName()" />
          </a>
          @if (!provider.isLogoDescriptive()) {
            <span class="provider-tile-image-name">{{ provider.getName() }}</span>
          }
        </div>
        <div class="provider-tile-top-text text-green">
          @if (!disabled) {
            @if (provider.isInstant()) {
              <span>
                <span class="bpi__icon-superfast instant-icon"></span>
                &nbsp;{{ "instant" | translate | uppercase }}
              </span>
            }
          }
        </div>
      </div>
      <div class="provider-tile-content">
        @if (!disabled) {
          <p>{{ provider.getDescription() }}</p>
          <p class="provider-tile-fees">
            @if (fee.free) {
              {{ "free" | translate | capitalize }}
            } @else {
              @if (showOnlyPercentFees) {
                <ng-container [ngTemplateOutlet]="percentFee"></ng-container>
              } @else {
                <ng-container [ngTemplateOutlet]="fixFee"></ng-container>
                <ng-container [ngTemplateOutlet]="percentFee"></ng-container>
                <ng-container [ngTemplateOutlet]="maxFee"></ng-container>
              }
            }
          </p>
          @if (provider.getFootnote(); as footnote) {
            <p class="provider-tile-footnote">{{ footnote }}</p>
          }
        } @else {
          <p class="small">{{ "only_available_for_FIATS" | translate: [fiatsAvailable] }}</p>
        }
      </div>
    </div>
  </div>
}

<ng-template #percentFee>
  @if (fee.getFeePercent(); as percents) {
    +
    {{ percents | truncate_fixed: fiat.getPrecision() | percent_symbol }}
  }
</ng-template>
<ng-template #fixFee>
  @if (fee.getFeeFix(); as fixedFee) {
    {{
    fixedFee
    | fiat_precision_symbol
    : {
    id: fiat.getId(),
    round: true,
    currencies: [fiat]
  }
  }}
}
</ng-template>
<ng-template #maxFee>
  @if (fee.getFeeMax(); as feeMax) {
    ({{ "fee_max" | translate }}
    {{
    feeMax
    | fiat_precision_symbol
    : {
    id: fiat.getId(),
    round: true,
    currencies: [fiat]
  }
  }})
}
</ng-template>
